import * as React from 'react';

interface Props {
  className?: string;
  iconography?: React.ReactNode;
  title: React.ReactNode;
  description?: React.ReactNode;
}

export const MessageCard: React.FC<Props> = (props) => {
  const { className, iconography, title, description } = props;
  return (
    <div className={`p-8 flex flex-col flex-grow gap-3 items-center justify-center ${className}`}>
      {iconography}
      <h4 className="uppercase font-bold text-gray-600 text-sm mb-3">{title}</h4>
      <div className="text-gray-700 text-sm text-center">{description}</div>
    </div>
  );
};
MessageCard.displayName = 'Shipments.DetailDrawer.Sections.PerDiem.MessageCard';
